<template>
    <span v-if="required" class="text-primary fw-bold fs-base">*</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'RequiredStar',
    props: {
        required: {
            type: Boolean,
            defalt: false,
        },
    },
});
</script>
